/** IST formatters and theme-aware colors for lightweight-charts. */

export const IST_HM = new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'Asia/Kolkata',
});

export function tsToChartTime(isoString) {
    return Math.floor(new Date(isoString).getTime() / 1000);
}

export function getChartColors(mode) {
    const isDark = mode === 'dark';
    return {
        text: isDark ? '#94a3b8' : '#64748b',
        grid: isDark ? 'rgba(148,163,184,0.1)' : 'rgba(148,163,184,0.18)',
        up: '#26a69a',
        down: '#ef5350',
        obi: '#ffa726',
        equity: '#42a5f5',
        buy: '#26a69a',
        sell: '#ef5350',
    };
}

export function baseChartOptions(mode, height) {
    const colors = getChartColors(mode);
    return {
        height,
        layout: {
            background: { type: 'solid', color: 'transparent' },
            textColor: colors.text,
        },
        grid: {
            vertLines: { color: colors.grid },
            horzLines: { color: colors.grid },
        },
        rightPriceScale: { borderVisible: false },
        timeScale: {
            borderVisible: false,
            timeVisible: true,
            secondsVisible: false,
        },
        localization: {
            timeFormatter: (time) => IST_HM.format(new Date(time * 1000)),
        },
        handleScroll: { vertTouchDrag: false },
    };
}
